import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import styles from './styles.module.scss'

import { getDocumentOverview } from '../../../api'

import { BackIcon } from '../Icons'
import AppNavbar from '../../Core/AppNavbar'
import Overview from './Overview'
import Employees from './Employees'
import Activities from './Activities'

const initData = {
  document: {
    category: {},
    document_type: {},
    files: [],
  },
  completion: {
    breakdown: [],
  },
  employees: [],
  activity: [],
}

const Document = ({companyId, documentId}) => {
  const { t } = useTranslation()
  const history = useHistory()

  const [loading, setLoading] = useState(false)
  const [{document, employees, completion, activity}, setData] = useState(initData)
  const [activeTab, setActiveTab] = useState('overview')

  const options = [{
    title: t('Overview'),
    key: 'overview',
  }, {
    title: t('Assigned Employees'),
    key: 'employees',
  }, {
    title: t('Activity List'),
    key: 'activities',
  }]

  useEffect(() => {
    fetchDocumentOverview(companyId, documentId)
  }, [companyId, documentId])

  const fetchDocumentOverview = async (companyId, documentId) => {
    setLoading(true)
    const res = await getDocumentOverview(companyId, documentId)
    if (res) {
      setData(res)
    }
    setLoading(false)
  }

  const handleSelectTab = (key) => {
    setActiveTab(key)
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <button type='button' className={styles.backButton} aria-label={t('Go back')} onClick={history.goBack}>
          <BackIcon />
        </button>
        <div className={styles.headerInfo}>
          <div className={styles.headerTitle}>{document.name}</div>
          <div className={styles.headerDesc}>
            {document.document_type.name}
            {' · '}
            {t('assigned to {{count}} employees', { count: employees.length })}
          </div>
        </div>
        <div className={styles.navWrapper}>
          <AppNavbar
            options={options}
            selected={activeTab}
            onSelect={handleSelectTab} />
        </div>
      </div>
      <div className={styles.content}>
        {
          (tab => {
            switch (tab) {
              case 'overview':
                return <Overview document={document} completion={completion} companyId={companyId} />
              case 'employees':
                return <Employees document={document} employees={employees} />
              case 'activities':
                return <Activities activities={activity} />
              default:
                return null
            }
          })(activeTab)
        }
      </div>
    </div>
  )
}

export default Document
